import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">专题索引</h2>
          <p className="text-sm text-foreground-500">按分类快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center text-center bg-background-100 rounded-lg p-5 md:p-6 cursor-pointer transition-colors duration-200 hover:bg-accent-50"
            >
              <div className="w-12 h-12 mb-3 rounded-lg bg-accent-100 flex items-center justify-center transition-colors duration-200 group-hover:bg-accent-200">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
              <div className="text-xs text-primary-600 font-medium mb-1.5">{item.count}</div>
              <p className="text-xs text-foreground-400">{item.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}